/**
 * @file: 优惠券
 * @author: wence
 */
import {rcAjax} from '../util';

export const getConpinInfo = params => rcAjax(
    'POST',
    '/xiapi/api/v1/pay/voucher',
    {},
    params,
    () => null
).then(data => data && data.data || {});

export const receiveConpin = params =>
    rcAjax(
        'POST',
        '/xiapi/api/v1/pay/receiveVoucher',
        {},
        params,
        () => null
    ).then(data => data && data.data || {});



// WEBPACK FOOTER //
// ./src/actions/conpinAction.js